/*---------------------------FORM OPTIONS ----------------------- */

export const CLIENT_OPTIONS = 'clientOptions';
export const MACHINES_OPTIONS = 'machinesOptions';
export const MACHINES_TYPES = 'machinesTypes';
export const LOCATIONS_OPTIONS = 'posLocations';
export const USERS_OPTIONS = 'users';
export const PROMOTION_USERS_OPTIONS = 'promotionUsers';
export const PROMOTIONS_OPTIONS = 'promotionsOptions';
export const LABELS_OPTIONS = 'labels';
export const CATEGORIES_OPTIONS = 'categories';
export const PRODUCTS_OPTIONS = 'products';
export const TAGS_OPTIONS = 'tags';
export const ACTIVATION_CODES_OPTIONS = 'activationCodes';
export const MACHINES_SERVICES = 'machinesServices';
export const CATALOGUES_OPTIONS = 'catalogues';
export const REPORTS_TYPES = 'reportsTypes';
export const REPORTS_COLUMNS = 'reportsColumns';
export const REPORTS_FILTERABLE_COLUMNS = 'reportsFilterableColumns';
export const REPORTS_GROUP_BY = 'reportsGroupBy';
export const REPORTS_GROUP_COLUMNS_ACTIONS_BATCH = 'reportsGroupColumnsActionsBatch';
export const REPORTS_GROUP_COLUMN_ACTIONS = 'reportsGroupColumnActions';
export const COMPANIES_OPTIONS = 'companies';
export const DELEGATIONS_OPTIONS = 'delegations';
export const AVAILABLE_DELEGATIONS = 'availableDelegations';
export const CURRENCY_OPTIONS = 'currencyOptions';
export const ROUTES_OPTIONS = 'routesOptions';
export const ROLES_OPTIONS = 'rolesOptions';
export const COUNTRIES_OPTIONS = 'countriesOptions';
export const MACHINE_FIRMWARE_OPTIONS = 'machineFirmwareOptions';
export const MACHINE_MODE_OPTIONS = 'machineModesOptions';
export const MACHINE_BRAND_OPTIONS = 'machineBrandOptions';
export const EMAIL_OPTIONS = 'emailOptions';
export const REFUND_REASONS_OPTIONS = 'refundReasonsOptions';

/*----------------------------BOXES----------------------------*/

export const USERS_BOXES = 'usersBoxes';
export const TAGS_BOXES = 'tagsBoxes';
export const CONCILIATIONS_BOXES = 'conciliationsBoxes';
export const POS_BOXES = 'posBoxes';
export const CUSTOMER_SERVICE_BOXES = 'customerServiceBoxes';

export const USER_INFO = 'userInfo';
export const TAG_INFO = 'tagInfo';

export const BOXES_QUERY_KEY = 'boxes';
export const HOME_BOXES_QUERY_KEY = 'homeBoxes';
export const ALERTS_BOXES_QUERY_KEY = 'alertsBoxes';

/*----------------------------OTHERS----------------------------*/
export const SIDEBAR_KEYS = 'sidebarKeys';
export const USER_AUDIT_LOG = 'userAuditLog';

/*---------------------------HOME CHARTS ---------------------- */
export const PAYMENT_METHODS_CHART = 'paymentMethodsChart';
export const TOTAL_SALES_CHART = 'totalSalesChart';
export const ERROR_PAYMENT_METHODS_CHART = 'errorPaymentMethodsChart';
